import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { OpenChatService } from 'src/app/services/OpenChat.service';
import { Subscription } from 'rxjs';
import {
  normalizeChatSearches,
} from 'src/app/guidGenerator';
import { OpenaiChatService } from 'src/app/services/openai-chat.service';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { BaseApi } from 'src/backend/api/base-api';
import { LoggedUser } from 'src/backend/models/session-users/session-users';

@Component({
  selector: 'app-openai-chat',
  templateUrl: './openai-chat.component.html',
  styleUrls: ['./openai-chat.component.scss'],
})
export class OpenaiChatComponent implements OnInit {
  isNewChat: boolean = true;
  isSearchValue: boolean = false;
  isRequestInProgress: boolean = false;
  savedSearches: any[] = [];
  savedSearchesFromDB: any[] = [];
  localData: any[] = [];
  selectedChatId: number = 0;
  selectedChatData: any[] = [];
  isNewSearch: boolean = false;
  newSearchData!: any;
  searchCtrl = new FormControl();
  userImage: any;
  blobStorage = Constants.BLOB_STORAGE_URL;
  apiRequestSubscription: Subscription | null = null;
  currentChat: {
    id: number;
    title: any;
    date: Date;
    searchData: {
      id: number;
      searchTerm: any;
      responseContent: any;
      Type: any;
      chartType: any;
    }[];
  };
  userProfile: LoggedUser;
  constructor(
    public openaiService: OpenaiChatService,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    private openChatService: OpenChatService,
    private cdr: ChangeDetectorRef,
    private baseApi: BaseApi,
  ) {}

  ngOnInit() {
    this.getProfileInformation()
    this.savedSearches = normalizeChatSearches(this.savedSearchesFromDB);
    this.chatSearchAdjustAutoHeight(false);
  }

  scrollContainer(): void {
    var scrollContainer = document.getElementById('scroll_area_container');
    if (scrollContainer === null) {
    } else {
      var scrollButton = document.getElementById('scroll_button');
      scrollContainer.scrollTop = scrollContainer?.scrollHeight;
      scrollContainer.addEventListener('scroll', function () {
        if (
          scrollContainer.clientHeight + scrollContainer.scrollTop <=
          scrollContainer.scrollHeight
        ) {
          scrollButton.style.visibility = 'visible';
        } else {
          scrollButton.style.visibility = 'hidden';
        }
      });
      scrollButton.addEventListener('click', function () {
        const scrollOptions: any = {
          top: scrollContainer.scrollHeight,
          behavior: 'smooth',
        };

        if ('scrollBehavior' in document.documentElement.style) {
          // Native smooth scrolling supported
          scrollContainer.scrollTo(scrollOptions);
        } else {
          // Polyfill for smooth scrolling
          smoothScrollTo(scrollContainer, scrollOptions.top, 1000); // Adjust the duration as needed
        }
      });
      // Polyfill for smooth scrolling
      function smoothScrollTo(element, target, duration) {
        var start = element.scrollTop,
          change = target - start,
          currentTime = 0,
          increment = 20;

        function animateScroll() {
          currentTime += increment;
          var val = easeInOutQuad(currentTime, start, change, duration);
          element.scrollTop = val;

          if (currentTime < duration) {
            setTimeout(animateScroll, increment);
          }
        }
        animateScroll();
      }
      // Easing function for smooth scrolling
      function easeInOutQuad(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      }
    }
  }
  getProfileInformation() {
    // this.userProfile = this.baseApi.getUserSession();
    // if (this.userProfile?.picture) {
    //   this.userImage = this.blobStorage + this.userProfile.picture;
    // } else {
    //   this.userImage = 'assets/images/img_avatar.png';
    // }
    this.userProfile = this.baseApi.getUserSession();
    this.userImage = this.userProfile?.picture;
  
  }

  chatSearchAdjustAutoHeight(removeText: boolean): void {
    const textarea: any = document.getElementById('chat_search_textarea');
    const chatSearchIcon: any = document.querySelector('#chat_search_icon');
    textarea.value = textarea.value.trim();
    textarea.addEventListener('input', function () {
      this.style.height = 'auto';
      this.style.height = this.scrollHeight + 'px';
      if (textarea.value.trim()) {
        this.isSearchValue = true;
        if (chatSearchIcon) {
          chatSearchIcon.classList.add('search_icon_color');
        }
      } else {
        this.isSearchValue = false;
        if (chatSearchIcon) {
          chatSearchIcon.classList.remove('search_icon_color');
        }
      }
    });
    if (removeText) {
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
      this.isSearchValue = false;
      if (chatSearchIcon) {
        chatSearchIcon.classList.remove('search_icon_color');
      }
    }
  }
  typeText(content: string, isEdit: boolean) {
    const contentElement = document.getElementById('new_search_content');
    const typingSpeed = 10; // Adjust the speed (in milliseconds) at which each character is typed
    let index = 0;
    // Replace newline characters with <br> tags
    content = content.replace(/\n/g, '<br>');
    const typing = () => {
      if (index < content.length) {
        const currentChar = content.charAt(index);
        if (currentChar === '<') {
          // Check if a "<br/>" tag is encountered
          const remainingContent = content.slice(index);
          if (remainingContent.startsWith('<br>')) {
            // Type the "<br/>" tag at once
            contentElement.innerHTML += '<br>';
            index += 5; // Skip the "<br/>" tag characters
          } else {
            contentElement.innerHTML += currentChar;
            index++;
          }
        } else {
          contentElement.innerHTML += currentChar;
          index++;
        }
        const lastChar = contentElement.innerHTML.charAt(
          contentElement.innerHTML.length - 1
        );
        if (
          lastChar === '\n' ||
          lastChar === '.' ||
          lastChar === ',' ||
          lastChar === '<br>'
        ) {
          this.scrollContainer();
        }
        setTimeout(typing, typingSpeed);
      } else {
        if (!isEdit) {
          this.savedSearchesFromDB.push({ ...this.newSearchData });
        }
        this.savedSearches = normalizeChatSearches(this.savedSearchesFromDB);
        this.newSearchData.searchData[0].responseContent =
          this.newSearchData.searchData[0].responseContent.replace(
            /\n/g,
            '<br>'
          );

        this.selectedChatData.push({ ...this.newSearchData });
        this.isNewSearch = false;
        this.newSearchData = [];
        this.scrollContainer();
      }
    };
    typing();
  }
  closeChatModel(): void {
    const chatModel = document.querySelector('#openai_chat_model');
    if (chatModel) {
      chatModel.classList.remove('chat_show');
      chatModel.classList.add('chat_hide');
    }
    const body = document.querySelector('body');
    body.style.overflow = 'auto';
    setTimeout(() => {
      this.openaiService.destroyComponent();
    }, 300);
  }

  closeSidePanel(): void {
    const sidePanel = document.querySelector('#chat_side_panel');
    const mainContent = document.querySelector('#chat_main');
    const showButton: any = document.querySelector('#show_sidebar_button');
    if (sidePanel) {
      sidePanel.classList.remove('chat_side_bar_panel_show');
      sidePanel.classList.add('chat_side_bar_panel_close');
    }
    if (mainContent) {
      mainContent.classList.remove('chat_main_content_width');
      mainContent.classList.add('chat_main_content_fullwidth');
    }
    if (showButton) {
      showButton.style.visibility = 'visible';
    }
  }
  showSidePanel(): void {
    const sidePanel = document.querySelector('#chat_side_panel');
    const showButton: any = document.querySelector('#show_sidebar_button');
    const mainContent = document.querySelector('#chat_main');
    if (sidePanel) {
      sidePanel.classList.remove('chat_side_bar_panel_close');
      sidePanel.classList.add('chat_side_bar_panel_show');
    }
    if (mainContent) {
      mainContent.classList.add('chat_main_content_width');
      mainContent.classList.remove('chat_main_content_fullwidth');
    }
    if (showButton) {
      showButton.style.visibility = 'hidden';
    }
  }

  startNewChat(): void {
    this.isNewChat = true;
    this.selectedChatId = 0;
    this.selectedChatData = [];
  }

  onClickChat(data: any): void {
    this.selectedChatId = data?.id;
    this.isNewChat = false;
    this.selectedChatData = data?.searchData ? data?.searchData : [];
    this.newSearchData = data;
    // this.selectedChatData.push({ ...this.newSearchData });
    this.createChart(data, true);
    // setTimeout(() => {
    //   this.scrollContainer();
    // }, 300);
  }

  searchNewQuery(): any {
    if (this.isRequestInProgress) {
      return;
    }
    this.isRequestInProgress = true;
    if (this.searchCtrl.value.trim() === '') {
      this.toaster.warning('Please enter some text to search', 'Warning');
      this.chatSearchAdjustAutoHeight(true);
      return;
    }
    let inputString = this.searchCtrl.value;
    let testDate = new Date();
    if (this.isNewChat && this.selectedChatId === 0) {
      // for new chat initialize calls for api will be make from here
      let obj = {
        query: this.searchCtrl.value.replace(/\n/g, ''),
        timeZoneHourDiff: Number(testDate.getTimezoneOffset() / 60),
      };
      this.searchCtrl.setValue('');
      // this.spinner.show();
      this.apiRequestSubscription = this.openChatService
        .askFromModel(obj)
        .subscribe(
          (data: any) => {
            const newChat = {
              id: Math.floor(Math.random() * 100000) + 1,
              title: inputString?.split(' ')?.slice(0, 6)?.join(' '),
              date: new Date(),
              searchData: [
                {
                  id: Date.now(),
                  searchTerm: inputString,
                  responseContent: data.agent_response,
                  Type: data.type || data.Type,
                  chartType: data?.chart_type,
                  module: data?.module,
                },
              ],
            };
            this.spinner.hide();
            this.isRequestInProgress = false;
            this.isNewChat = false;
            this.chatSearchAdjustAutoHeight(true);
            this.cdr.detectChanges();
            console.log('found2', { ...newChat });
            this.isNewSearch = true;
            this.selectedChatId = newChat.id;
            this.currentChat = newChat;
            this.newSearchData = { ...newChat };
            console.log('from second response');
            if (
              newChat.searchData[0].Type == 'chart' ||
              newChat.searchData[0].Type == 'bar' ||
              this.newSearchData?.searchData[0]?.Type == 'list' ||
              newChat.searchData[0].Type == 'chart/list'
            ) {
              this.createChart(
                this.newSearchData?.searchData[0]?.responseContent,
                false
              );
            } else {
              setTimeout(() => {
                this.typeText(
                  this.newSearchData?.searchData[0]?.responseContent.replace(
                    /\n/g,
                    '<br>'
                  ),
                  false
                );
              }, 300);
            }
          },
          (error: any) => {
            this.spinner.hide();
            this.toaster.error('Error', error.message);
          }
        );
    }
    if (!this.isNewChat && this.selectedChatId > 0) {
      // for existing chat searches calls for api will be make from here
      const found = this.savedSearchesFromDB.find(
        (x) => x.id === this.selectedChatId
      );
      if (found) {
        let obj = {
          query: this.searchCtrl.value.replace(/\n/g, ''),
          timeZoneHourDiff: Number(testDate.getTimezoneOffset() / 60),
        };
        this.searchCtrl.setValue('');
        // this.spinner.show();
        this.apiRequestSubscription = this.openChatService
          .askFromModel(obj)
          .subscribe(
            (data: any) => {
              if ((data.type || data.Type) === 'Textual-Answer') {
                data.agent_response = data.agent_response.replace(
                  /\n/g,
                  '<br>'
                );
              }
              found.searchData.push({
                id: Date.now(),
                searchTerm: inputString,
                responseContent: data.agent_response,
                Type: data.type || data.Type,
                chartType: data?.chart_type,
                module: data?.module,
              });
              this.spinner.hide();
              this.isRequestInProgress = false;
              this.chatSearchAdjustAutoHeight(true);
              this.cdr.detectChanges();
              this.isNewSearch = true;
              this.currentChat = found;
              this.newSearchData = { ...found };
              if (
                this.newSearchData?.searchData[0]?.Type == 'chart' ||
                this.newSearchData?.searchData[0]?.Type == 'bar' ||
                this.newSearchData?.searchData[0]?.Type == 'list' ||
               this.newSearchData.searchData[0].Type == 'chart/list'
              ) {
                this.createChart(
                  this.newSearchData?.searchData[1]?.responseContent,
                  true
                );
              } else {
                setTimeout(() => {
                  const input = this.newSearchData?.searchData.find(
                    (x) => x.Type == 'Textual-Answer'
                  );
                  this.typeText(input.responseContent, true);
                }, 300);
              }
            },
            (error: any) => {
              this.spinner.hide();
              this.toaster.error('Error', error.message);
              this.isRequestInProgress = false;
            }
          );
      }
    }
  }

  stopGeneratingResponse(): void {
    if (this.apiRequestSubscription) {
      this.apiRequestSubscription.unsubscribe();
      this.isRequestInProgress = false;
    }
  }

  createChart(content: string, isEdit: Boolean) {
    if (!isEdit) {
      this.savedSearchesFromDB.push({ ...this.newSearchData });
      this.selectedChatData = [];
    }
    this.savedSearches = normalizeChatSearches(this.savedSearchesFromDB);
    this.selectedChatData.push({ ...this.newSearchData });
    // this.localData.push({...this.newSearchData})
    // localStorage.setItem('chatData', JSON.stringify(this.localData));
    // console.log('local storage data',this.localData)
    this.isNewSearch = false;
    this.newSearchData = [];
    this.scrollContainer();
  }

  ngOnDestroy(): void {
    if (this.apiRequestSubscription) {
      this.apiRequestSubscription.unsubscribe();
    }
  }
}
